import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from 'app/app.config';
import { LocalStorageService } from 'app/core/services/local-storage/local-storage.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'Teranet-ReportDashboard',
  templateUrl: './report-dashboard.component.html'
})
export class ReportDashboardComponent implements OnInit {
  Hangfireurl: string;
  url: SafeResourceUrl;
  PowerBIUrl: string;
  constructor(private cookieService: CookieService,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService) {

    this.PowerBIUrl = ((AppConfig.settings != undefined) && AppConfig.settings) ? AppConfig.settings.settings.PowerBI_Url : this.localStorageService.getItem('PowerBI_Url');
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.PowerBIUrl);
  }
  ngOnInit() {
  }
}
